export enum TemplateActions {
  CreateTemplate,
  EditTemplate,
}
